import axios from 'axios';
import config from './config';



////////// For General API Requests //////////
// This instance is used for general API requests without authentication
const axiosInstance = axios.create({
	baseURL: config.serverUrl,
	headers: {
		'Access-Control-Allow-Origin': '*',
		"ngrok-skip-browser-warning": true
	}
});



////////// For Basic Authenticated Requests //////////
export const axiosBasicAuthInstance = axios.create({
	baseURL: config.serverUrl,
	auth: {
		username: config.serverUrl,
		password: config.serverUrl,
	},
	headers: {
		'Content-Type': 'application/json',
		'Accept': 'application/json',
	},
});




export default axiosInstance;
